import { ResourceHelperService } from '../resource-helper.service';
import { LinkBuilder } from '../link-builder.service';
import { QueryBuilder } from '../query-builder.service';

export class ChargeAccountActionsService {

  public resource: ng.resource.IResourceClass<ng.resource.IResource<InterACT.Interfaces.ChargeAccounts.ChargeAccount | InterACT.Interfaces.ChargeAccounts.ChargeAccountActionsResponse>>;

  constructor(
    $resource: ng.resource.IResourceService,
    private resourceHelperService: ResourceHelperService,
    private linkBuilder: LinkBuilder,
    private queryBuilder: QueryBuilder) {
    this.resource = $resource('api/charge-account-actions');
  }

  /**
   * A method to create an action against a charge account with the supplied id
   * @param chargeAccountAction the charge account action to create
   */
  public create(chargeAccountAction: InterACT.Interfaces.ChargeAccounts.ChargeAccountAction) {
    return this.resource.save(chargeAccountAction).$promise;
  }

  /**
   * A method that gets a list of charge account actions using a given query
   * @param page the number of records to retrieve
   * @param perPageCount 0
   * @param query the query to use when querying the service
   */
  public getList(page: number, perPageCount: number, query: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, query);
    return <ng.IPromise<InterACT.Interfaces.ChargeAccounts.ChargeAccountActionsResponse>>this.resource.get(options).$promise;
  }

  /**
   * A method that gets the last created charge account action for a given charge account
   */
  public getLastAction(chargeAccountId: string): ng.IPromise<InterACT.Interfaces.ChargeAccounts.ChargeAccountActionsResponse> {
    const link = this.linkBuilder.getChargeAccountLink(chargeAccountId);
    const query = this.queryBuilder.newParam().fieldIs('chargeAccount.link', link).sortBy([
      {
        columnName: 'created',
        direction: 'desc'
      }
    ]).getParam();
    return this.getList(1, 1, query);
  }
}